<template>
  <div class="AdminNotification">
    <el-row width="100%">
      <el-button type="primary" @click="createNotification()"
        >お知らせを作成</el-button
      >
    </el-row>
    <div id="noti" class="NotiTableHeader">
      <el-table
        :data="notifications"
        border
        :height="tableHeight"
        class="NotiTable"
        style="text-align:center"
        header-row-class-name="NotiTable-HeaderRow"
        header-cell-class-name="NotiTable-HeaderCell"
        cell-class-name="NotiTable-Cell"
        @row-click="goToDetailMessage($event)"
      >
        <el-table-column prop="title" label="タイトル" />
        <el-table-column label="メッセージ">
          <template slot-scope="scope">
            <p v-if="scope.row.body.length > 50">
              {{ scope.row.body.substring(0, 50) }} ．．．
            </p>
            <p v-else>{{ scope.row.body }}</p>
          </template>
        </el-table-column>
        <el-table-column label="通知日時" align="center">
          <template slot-scope="scope">
            {{ scope.row.createdAt | humanize.date }}
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-dialog :visible.sync="detailDialog" width="40%">
      <p>{{ createdAt | humanize.date }}</p>
      <p>{{ title }}</p>
      <p>{{ body }}</p>
    </el-dialog>
  </div>
</template>

<script>
import NotificationUsecase from "@/usecases/notification.usecase";
import { apiErrorHandler } from "@/services/apiErrorHandler";
export default {
  components: {},
  data () {
    return {
      notificationUsecase: new NotificationUsecase(),
      notifications: [],
      detailDialog: false,
      createdAt: "",
      title: "",
      body: "",
      showForm: false,
      tableHeight: screen.height - 244,
    };
  },
  async created () {
    const loading = this.$loading();
    try {
      this.notifications = await this.notificationUsecase
        .getNotifications()
        .then(notifications => {
          loading.close();
          return notifications;
        });
    } catch (err) {
      apiErrorHandler(this, err);
    }
  },
  methods: {
    goToDetailMessage (item) {
      this.detailDialog = true;
      this.createdAt = item.createdAt;
      this.title = item.title;
      this.body = item.body;
    },
    createNotification () {
      const { $router } = this;
      $router.push("/admin/notification/create");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/variables.scss";

::v-deep .el-table th {
  text-align: center !important;
  background-color: $background-gray-base !important;
}
::v-deep .NotiTable {
  width: 100% !important;
}
::v-deep .NotiTable .el-table__row {
  cursor: pointer !important;
}
::v-deep .NotiTable .NotiTable-Cell .cell {
  margin-left: 1.5rem;
  margin-right: 1.5rem;
}
</style>

<style lang="scss" scoped>
@import "~@/assets/styles/variables.scss";

.AdminNotification {
  margin-top: 1rem;
  width: 99%;
  margin-left: 0.7rem;
}
.AdminNotification .el-col {
  line-height: 2.5;
}
.AdminNotification .el-dialog__body {
  padding: 16px 43px !important;
  font-size: 16px;
}
.AdminNotification .notiText {
  font-size: 16px;
}
.AdminNotification .el-dialog__headerbtn {
  top: -21px !important;
  font-size: 14px !important;
  right: 0 !important;
}
.AdminNotification .el-dialog__headerbtn .el-dialog__close {
  color: white !important;
}
.AdminNotification .el-icon-close::after {
  content: "閉じる";
}
.AdminNotification .el-button {
  float: right;
  margin-bottom: 1rem;
  margin-right: 1.6rem;
}
.AdminNotification .el-table th {
  background-color: $background-gray-deep !important;
}
</style>
